import { Outlet, useParams } from 'react-router-dom'
import { useClient } from '@/api/queries'
import { TopBar } from '@/components/app/TopBar'
import { NavRail } from '@/components/app/NavRail'
import { ClientBanner } from '@/components/app/ClientBanner'

/**
 * Topbar + nav rail + client banner + outlet.
 *
 * `clientId` comes from the route param and nowhere else — that is the whole
 * tenant-scope story (docs/02-app-shell.md §3). Two tabs can hold two clients
 * without cross-contamination, and a leak requires a routing bug rather than
 * a state bug.
 */
export function AppShell() {
  const { clientId } = useParams()
  const { data: client } = useClient(clientId ?? '')

  return (
    <div className="min-h-screen bg-canvas">
      <TopBar />
      <div className="flex items-start">
        <NavRail clientId={clientId ?? null} />
        <div className="min-w-0 flex-1">
          {clientId && client && <ClientBanner client={client} />}
          <main className="mx-auto w-full max-w-[1440px] p-6">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  )
}
